/* eslint import/prefer-default-export: 0 */

import { API_CALL } from '../constants/actionTypes';
import { FAQS, RULES, STATIC_CONTENT } from '../constants/apiTypes';
import { getStaticContent } from '../api/content';

export function fetchFaqs(link = 'faqs') {
  return {
    type: API_CALL,
    api: FAQS,
    request: getStaticContent(link)
  };
}

export function fetchRules() {
  return {
    type: API_CALL,
    api: RULES,
    request: getStaticContent('rules')
  };
}

export function fetchStaticContent(key) {
  return {
    type: API_CALL,
    api: STATIC_CONTENT,
    request: getStaticContent(key).then(res => ({ ...res, key })),
    key
  };
}
